export interface Filters {
    groupId: number[];
    responseId: number[];
    eventTypeId: number[];
    userId: number[];
    eventOutcomeId: any[];
    serverTypeEventNum: any[];
    excludeAutoHandled: { id: number, title: string };
    resultCount: { id: number, title: string };
    dynamicdata?: any;
    startDate: any;
    endDate: any;
    excludeFilters: ExcludedFilter[];
    startTime: string;
    endTime: string;
    days: any[],
    excludeParkedTime: { id: number, title: string };
    ignoreDateTime: { id: number, title: string };
}

export enum FilterOptions {
    Select = "Select",
    MultiSelect = "MultiSelect",
    Date = "Date",
    DateTime ="DateTime",
    NestedEventOutcomes = "NestedEventOutcomes",
    DynamicData = "DynamicData",
    ComplexMultiSelect = "ComplexMultiSelect",
    Text = "Text",
    ExcludeFilters = "ExcludeFilters"
}

export enum FilterNames {
    EXCLUDE_AUTO_HANDLED = "excludeAutoHandled",
    SERVER_TYPE_EVENT = "serverTypeEventNum",
    EVENT_TYPE = "eventTypeId",
    GROUP = "groupId",
    EVENT_OUTCOME = "eventOutcomeId",
    RESPONSE = "responseId",
    USER = "userId",
    EVENT_RECORD_TYPE = "eventRecordTypeId",
    START_DATE = "startDate",
    END_DATE = "endDate",
    RESULT_COUNT = "resultCount",
    SHIFT = "shifts",
    TEXT = "Text",
    EXCLUDE_UNPOPULATED_RESTULTS = "excludeUnpopulatedResults",
    DETAILS = "details",
    NOTES = "notes",
    EXCLUDE_FILTERS = "excludeFilters",
    DAYS = "days",
    EXCLUDE_PARKED_TIME = "excludeParkedTime",
    IGNORE_DATE_TIME = "ignoreDateTime"
}

export interface ExcludedFilter {
    filterType: string;
    value: boolean;
    filterName: string;
}

// Filters which are allowed to be excluded/included.
export enum ExcludableFilters {
    SERVER_TYPE_EVENT = "serverTypeEventNum",
    EVENT_TYPE = "eventTypeId",
    GROUP = "groupId",
    EVENT_OUTCOME = "eventOutcomeId",
    RESPONSE = "responseId",
    USER = "userId",
    EVENT_RECORD_TYPE = "eventRecordTypeId",
    START_DATE = "startDate",
    END_DATE = "endDate",
    SHIFT = "shifts",
    TEXT = "Text",
    DETAILS = "details",
    NOTES = "notes",
    EXCLUDE_FILTERS = "excludeFilters",
    LICENSE_GROWTH_TYPE = "licenseGrowthType",
    LICENSE_DEVICE_TYPE = "licenseDeviceType",
    LINK_UNLINK = "linkUnlink"
}

export interface FilterOption {
	data?: any;
	filterName: FilterNames;
	title: string;
	type: FilterOptions;
}

export interface EmitFilter {
	filterName: FilterNames;
	title: string;
    type: FilterOptions;
    filter: any;
}

export interface EmitExclude {
    filterType: FilterOptions;
    filterName: FilterNames;
    state: boolean;
}

export interface EventOutcome {
    id: number,
    parentId: number,
    title: string
}